module.exports = __webpack_public_path__ + "static/fluent-callout-3cfa204d0723d2cad615fa41a57e2688.png";